export default __webpack_public_path__ + "static/media/poster.56192858.png";